import {CancelTokenSource} from "axios";

import {appApi, travelAllowanceApi} from "@services/api.service";
import {getWorkerId} from "@utils/tools/worker";

import {PlaceOfService, RideRoute, RideRouteForm} from "@models/travelAllowance/rideRoute";
import {Coordinator} from "@models/travelAllowance/ride";
import moment from "moment/moment";
import {Coordinates} from "@models/google/googleMaps";

const getRideRoutes = async (cancelToken?: CancelTokenSource): Promise<RideRoute[]> => {
    const workerId = await getWorkerId();
    const response: any = await travelAllowanceApi.get(`ride-routes/worker/${workerId}`, {
        cancelToken: cancelToken?.token
    });

    return response.data;
}

const getRideRoute = async (rideRouteId: number, cancelToken?: CancelTokenSource): Promise<RideRoute> => {
    const workerId = await getWorkerId();
    const response: any = await travelAllowanceApi.get(`ride-routes/${rideRouteId}/worker/${workerId}`, {
        cancelToken: cancelToken?.token
    });

    return response.data;
}

const addRideRoute = async (rideRouteData: RideRouteForm) => {
    const workerId = await getWorkerId();

    return travelAllowanceApi.post(`ride-routes/worker/${workerId}`, rideRouteData)
}

const editRideRoute = async (rideRouteId: number, rideRouteData: RideRouteForm) => {
    const workerId = await getWorkerId();

    return travelAllowanceApi.put(`ride-routes/${rideRouteId}/worker/${workerId}`, rideRouteData)
}

const removeRideRoute = async (rideRouteId: number) => {
    const workerId = await getWorkerId();

    return travelAllowanceApi.patch(`ride-routes/${rideRouteId}/worker/${workerId}/unlink-worker`)
}

const getPossibleCoordinators = async (date?: string, cancelToken?: CancelTokenSource, page: number = 1, searchText: string = ''): Promise<Coordinator[]> => {
    let url = `route/possible-coordinators?page=${page}&searchText=${searchText}`;

    if (date) {
        url = url + `&date=${moment(date).format('YYYY-MM-DD')}`;
    }

    const response: any = await appApi.get(url, {
        cancelToken: cancelToken?.token
    });

    return response.data;
}

const getPlacesOfService = async (coordinatorId: number, startingPlaceCoordinates?: Coordinates, destinationPlaceCoordinates?: Coordinates, localizationDistanceLimit?: number, cancelToken?: CancelTokenSource, page: number = 1, searchText: string = ''): Promise<PlaceOfService[]> => {
    let url = `route/possible-places-of-service?coordinatorId=${coordinatorId}&page=${page}&searchText=${searchText}`;

    if (startingPlaceCoordinates) {
        url = url + `&startLatitude=${startingPlaceCoordinates.latitude}&startLongitude=${startingPlaceCoordinates.longitude}`;
    }

    if (destinationPlaceCoordinates) {
        url = url + `&destinationLatitude=${destinationPlaceCoordinates.latitude}&destinationLongitude=${destinationPlaceCoordinates.longitude}`;
    }

    if (localizationDistanceLimit) {
        url = url + `&localizationDistanceLimit=${localizationDistanceLimit}`;
    }

    const response: any = await appApi.get(url, {
        cancelToken: cancelToken?.token
    });

    return response.data;
}

const validateRideRoute = async (rideRouteId: number, date?: string) => {
    if (date) {
        date = moment(date).format('YYYY-MM-DD');
    }

    return travelAllowanceApi.post(`ride-routes/${rideRouteId}/validate` + (date ? `?date=${date}` : ''));
}

export {
    getRideRoutes,
    getRideRoute,
    addRideRoute,
    editRideRoute,
    removeRideRoute,
    getPossibleCoordinators,
    getPlacesOfService,
    validateRideRoute,
};
